import { defineLocale } from "../../registry";

const transitions = defineLocale({
  ru: {
    "transitions.group": "Смена статуса",
    "transitions.blockedByDrafts":
      "Есть несохранённые изменения. Сохраните или отмените их, прежде чем менять статус.",
    "transitions.action.unpublish": "Снять с публикации",
    "transitions.action.archive": "Архивировать",
    "transitions.action.restore": "Восстановить",
    "transitions.dialog.unpublish.title": "Снять Pick с публикации?",
    "transitions.dialog.archive.title": "Архивировать Pick?",
    "transitions.dialog.unpublish.body":
      "Pick перестанет быть доступен пользователям, запись вернётся в черновики.",
    "transitions.dialog.archive.body":
      "Pick будет перенесён в архив и пропадёт из выдачи.",
    "transitions.reason.label": "Причина",
    "transitions.audit": "Действие зафиксировано в Audit Log",
    "transitions.confirm": "Подтвердить",
    "transitions.done.unpublish": "Pick снят с публикации",
    "transitions.done.archive": "Pick перенесён в архив",
    "transitions.done.restore": "Pick восстановлен как черновик",
    "transitions.error.invalidTransition": "Статус уже изменён",
    "transitions.gateItems.title": "Не выполнено на сервере",
    "transitions.error.partnerFactsStale":
      "Публикация заблокирована: устарели факты партнёра",
    "transitions.stale.title": "Что нужно обновить",
    "transitions.stale.retry": "Обновите факты и опубликуйте снова",
    "transitions.stale.fact.price": "Цена",
    "transitions.stale.fact.link": "Ссылка",
    "transitions.stale.fact.unknown": "Неизвестный факт",
    "transitions.stale.option": "Опция «{title}»",
    "transitions.stale.optionN": "Опция {n}",
    "transitions.stale.state.expired": "Цена устарела",
    "transitions.stale.state.unconfirmed": "Ссылка не подтверждена",
    "transitions.stale.state.urlChangePending":
      "Запрос на смену URL ждёт применения вторым суперадмином",
    "transitions.stale.state.unknown": "Состояние не распознано",
    "transitions.stale.hint.price":
      "Перепроверьте цену у партнёра и обновите поле «Цена проверена» на вкладке Basics.",
    "transitions.stale.hint.link":
      "Подтвердите ссылку через «Проверка ссылки» в блоке «Партнёрская ссылка» (роль superadmin).",
    "transitions.stale.hint.urlChangePending":
      "Запрос на смену URL должен применить второй суперадмин; после этого подтвердите ссылку через «Проверка ссылки» (роль superadmin).",
  },
  en: {
    "transitions.group": "Status actions",
    "transitions.blockedByDrafts":
      "There are unsaved changes. Save or discard them before changing the status.",
    "transitions.action.unpublish": "Unpublish",
    "transitions.action.archive": "Archive",
    "transitions.action.restore": "Restore",
    "transitions.dialog.unpublish.title": "Unpublish this Pick?",
    "transitions.dialog.archive.title": "Archive this Pick?",
    "transitions.dialog.unpublish.body":
      "The Pick will no longer be available to users and returns to drafts.",
    "transitions.dialog.archive.body":
      "The Pick will be moved to the archive and removed from the catalog feed.",
    "transitions.reason.label": "Reason",
    "transitions.audit": "The action is recorded in the Audit Log",
    "transitions.confirm": "Confirm",
    "transitions.done.unpublish": "The Pick was unpublished",
    "transitions.done.archive": "The Pick was archived",
    "transitions.done.restore": "The Pick was restored as a draft",
    "transitions.error.invalidTransition": "The status has already changed",
    "transitions.gateItems.title": "Not satisfied on the server",
    "transitions.error.partnerFactsStale":
      "Publishing is blocked: partner facts are out of date",
    "transitions.stale.title": "What to update",
    "transitions.stale.retry": "Update the facts, then publish again",
    "transitions.stale.fact.price": "Price",
    "transitions.stale.fact.link": "Link",
    "transitions.stale.fact.unknown": "Unrecognised fact",
    "transitions.stale.option": "Option “{title}”",
    "transitions.stale.optionN": "Option {n}",
    "transitions.stale.state.expired": "The price is out of date",
    "transitions.stale.state.unconfirmed": "The link is not confirmed",
    "transitions.stale.state.urlChangePending":
      "The URL change request is waiting for a second superadmin to apply it",
    "transitions.stale.state.unknown": "The state is not recognised",
    "transitions.stale.hint.price":
      "Re-check the price with the partner and update “Price verified on” in the Basics tab.",
    "transitions.stale.hint.link":
      "Confirm the link with Link check in the Partner link block (superadmin role).",
    "transitions.stale.hint.urlChangePending":
      "A second superadmin must apply the URL change request; then confirm the link with Link check (superadmin role).",
  },
});

export default transitions;
